import { FC } from 'react';
import { useSearchStore } from '../../stores/search';



export const AlphabetSelectMenu: FC = () => {
  const alphabetBg = 'абвгдежзийклмнопрстуфхцчшщъьюя';
  const alphabetArray = Array.from(alphabetBg);
  const { setAlphabetSearchCharacter, alphabetSearchCharacter, setCurrentCategoryId, setSearchQueryInput } = useSearchStore((state) => state);
  
  return (
    <div className="">
      <select
        value={alphabetSearchCharacter}
        className={'rounded-xl w-full px-2 py-3'}
        name={'AlphabetSearch'}
        onChange={(e) => {
          setAlphabetSearchCharacter(e.target.value);
          setSearchQueryInput('')
          setCurrentCategoryId('');
        }}>
        <option selected disabled={true} value={''}> Търси по буква</option>
        {alphabetArray.map((word,  index) => (
          <option key={index} value={word}>{word.toUpperCase()}</option>
        ))}
      </select>
    </div>
  );
};
